import React, { Component } from "react"
import Icon from "../../components/icon-v2"
import {
    StyledNavGroup,
    StyledNavGroupHeader,
    StyledIcon,
    StyledNavGroupChildren,
} from "./partials/StyledMenu"

class NavGroup extends Component {
    state = {
        displayChildren: this.props.defaultOpen,
    }
    toggleChildren = () => {
        const { displayChildren } = this.state

        this.setState({
            displayChildren: !displayChildren,
        })
    }
    render() {
        const { displayChildren } = this.state
        return ( 
            <StyledNavGroup pageNavTheme={this.props.pageNavExists} isActive={this.props.isActive} isOpen={this.props.isOpen}>
                <StyledNavGroupHeader pageNavTheme={this.props.pageNavExists} isActive={this.props.isActive} onClick={this.toggleChildren}>
                    <p>{this.props.title}</p>
                    <StyledIcon pageNavTheme={this.props.pageNavExists} isOpen={displayChildren}>
                        <Icon icon="chevron-down" />
                    </StyledIcon>
                </StyledNavGroupHeader>
                <StyledNavGroupChildren isOpen={displayChildren}>
                    {this.props.children}
                </StyledNavGroupChildren>
            </StyledNavGroup>
        )
    }
}

export default NavGroup
